import type { ExternalRoute, PageRoute } from "@/shared/navigation";
import { RobotoEndpoint } from "@/types";

export enum Title {
  Account = "Account",
  ActionHub = "Action Hub",
  Actions = "Actions",
  Admin = "Admin",
  Collections = "Collections",
  Devices = "Devices",
  Docs = "Docs",
  Home = "Home",
  Logout = "Log out",
  NewDataset = "New Dataset",
  Notifications = "Notifications",
  Search = "Search",
  Settings = "Settings",
}

export enum Alignment {
  Left = "left",
  Right = "right",
  Center = "center",
}

export interface RobotoNavigationProps {
  sideBarWidth: string;
  topBarHeight: string;
}

export interface NavItemData {
  title: Title;
  link: PageRoute | ExternalRoute;
  alignment: Alignment;
  target?: string;
  Icon: React.ElementType;
}

export const notificationsEndpoint: RobotoEndpoint = (pathParams) => {
  if (pathParams && pathParams.notificationId) {
    return `/notifications/${pathParams.notificationId}`;
  }

  return `/notifications`;
};

export const getCommentEndpoint: RobotoEndpoint = (pathParams) => {
  if (pathParams && pathParams.commentId) {
    return `/comments/${pathParams.commentId}`;
  }

  throw new Error("No commentId provided");
};
